import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { WWW_URL } from '@/lib/urls'
import { HEADERS } from '@/constants'
import { env } from '@/lib/runtimeEnv'

const VERSION = env.VITE_TAG_NAME as string | undefined

const defaultConfig: AxiosRequestConfig = {
  baseURL: WWW_URL,
  timeout: 60000,
  headers: {
    Accepts: 'application/json',
  },
  withCredentials: true,
  withXSRFToken: true,
}

if (VERSION) {
  defaultConfig.headers[HEADERS.SPA_VERSION] = VERSION
}

const axiosInstance = (
  asForm = false,
  config = defaultConfig
): AxiosInstance => {
  if (asForm) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }

  return axios.create(config)
}

export default axiosInstance
